module.exports = __webpack_public_path__ + "static/media/2.Marble Cutter.6c344ef7.jpg";